import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import tinymce from "vue-tinymce-editor";
import Vuetify from "vuetify/lib";
import VueCookies from "vue-cookies";
import JsonExcel from "vue-json-excel";
import VueExcelXlsx from "vue-excel-xlsx";
import CircularComponent from "./components/master/CircularDocument.vue"

// console.log(config)

var infiniteScroll = require("vue-infinite-scroll");

console.log(window.location.pathname);
console.log(`config.json`);
fetch(`${process.env.VUE_APP_PUBLIC_PATH}/config.json`.replace("//", "/"))
  .then((res) => res.json())
  .then((config) => {
    console.log(`config`);
    //console.log(config);
    Vue.prototype.$VUE_APP_URL_API = config.VUE_APP_URL_API;
    Vue.prototype.$VUE_APP_SYSTEM_NAME_SHORT = config.VUE_APP_SYSTEM_NAME_SHORT;
    Vue.prototype.$VUE_APP_COMPANY_MOBILE = config.VUE_APP_SYSTEM_NAME_SHORT;
    Vue.prototype.$VUE_APP_URL_API_USER_MGNT = `${config.VUE_APP_URL_API_USER_MGNT}/api/`;
    Vue.prototype.$VUE_APP_URL_API_MAIN_PROCESS = `${config.VUE_APP_URL_API_MAIN_PROCESS}/api/`;
    Vue.prototype.$VUE_APP_URL_API_SYSTEM_CONFIG = `${config.VUE_APP_URL_API_SYSTEM_CONFIG}/api/`;
    Vue.prototype.$VUE_APP_URL_API_GENERATE_PDF = `${config.VUE_APP_URL_API_GENERATE_PDF}/`;
    Vue.prototype.$VUE_APP_URL_API_AUTHEN = `${config.VUE_APP_URL_API_AUTHEN}/`;
    Vue.prototype.$VUE_APP_URL_CONFIG = `${config.VUE_APP_URL_API_SYSTEM_CONFIG}/api/SystemConfig/`;
    Vue.prototype.$VUE_APP_URL_API_RESERVE = `${config.VUE_APP_URL_API_RUNNING}/api/Reserve/`;
    Vue.prototype.$VUE_APP_URL_API_RUNNING = `${config.VUE_APP_URL_API_RUNNING}/Running/`;
    Vue.prototype.$VUE_APP_URL_API_STORAGE = `${config.VUE_APP_URL_API_STORAGE}/api/FileStorage`;
    Vue.prototype.$VUE_APP_URL_API_WORK_ASSIGN = `${config.VUE_APP_URL_API_USER_MGNT}/api/WorkAssignment/`;
    Vue.prototype.$VUE_APP_URL_API_DOCTYPE = `${config.VUE_APP_URL_API_USER_MGNT}/api/DocumentType/`;
    Vue.prototype.$VUE_APP_URL_API_EMAIL = `${config.VUE_APP_URL_API_EMAIL}`;
    Vue.prototype.$VUE_APP_URL_API_EXTERNALDOCUMENT = `${config.VUE_APP_URL_API_EXTERNALDOCUMENT}/`;
    Vue.prototype.$VUE_APP_ACCESS_KEY_USER_MNGT = `${config.VUE_APP_ACCESS_KEY_USER_MNGT}`;
    Vue.prototype.$VUE_APP_ACCESS_KEY_CONFIG = `${config.VUE_APP_ACCESS_KEY_CONFIG}`;
    Vue.prototype.$VUE_APP_URL_API_ECMS = `${config.VUE_APP_URL_API_ECMS}`;
    Vue.prototype.$VUE_APP_ALLOW_EDIT_USER = false;

    fetch(
      `${config.VUE_APP_URL_API_SYSTEM_CONFIG}/api/SystemConfig/GetByKey/EDIT_USER_PROFILE?API_ACCESS_KEY=${config.VUE_APP_ACCESS_KEY_CONFIG}`
    )
      .then((res) => res.json())
      .then((item) => {
        Vue.prototype.$VUE_APP_ALLOW_EDIT_USER = item.value;
      });

    fetch(
      `${config.VUE_APP_URL_API_SYSTEM_CONFIG}/api/SystemConfig/GetByKey/COMPANY?API_ACCESS_KEY=${config.VUE_APP_ACCESS_KEY_CONFIG}`
    )
      .then((res) => res.json())
      .then((item) => {
        Vue.prototype.$VUE_APP_SYSTEM_NAME_LONG = item.value;
      });

    fetch(
      `${config.VUE_APP_URL_API_SYSTEM_CONFIG}/api/SystemConfig/GetByKey/ECMS?API_ACCESS_KEY=${config.VUE_APP_ACCESS_KEY_CONFIG}`
    )
      .then((res) => res.json())
      .then((item) => {
        Vue.prototype.$VUE_APP_ECMS = item.value;
      });

    fetch(
      `${config.VUE_APP_URL_API_SYSTEM_CONFIG}/api/SystemConfig/GetByKey/EMAIL?API_ACCESS_KEY=${config.VUE_APP_ACCESS_KEY_CONFIG}`
    )
      .then((res) => res.json())
      .then((item) => {
        Vue.prototype.$VUE_APP_EMAIL = item.value;
      });

    fetch(
      `${config.VUE_APP_URL_API_SYSTEM_CONFIG}/api/SystemConfig/GetByKey/COMPANY_SHOT?API_ACCESS_KEY=${config.VUE_APP_ACCESS_KEY_CONFIG}`
    )
      .then((res) => res.json())
      .then((item) => {
        Vue.prototype.$VUE_APP_SYSTEM_NAME_SHORT = item.value;
        Vue.prototype.$VUE_APP_COMPANY_MOBILE = item.value;
      });

    fetch(
      `${config.VUE_APP_URL_API_SYSTEM_CONFIG}/api/SystemConfig/GetByKey/DEPARTMENT_CENTER_CODE?API_ACCESS_KEY=${config.VUE_APP_ACCESS_KEY_CONFIG}`
    )
      .then((res) => res.json())
      .then((item) => {
        Vue.prototype.$VUE_APP_DEPT_CENTER_CODE = item.value;
      });

    fetch(
      `${config.VUE_APP_URL_API_SYSTEM_CONFIG}/api/SystemConfig/GetByKey/FIXED_DEPARTMENT_RUNNING?API_ACCESS_KEY=${config.VUE_APP_ACCESS_KEY_CONFIG}`
    )
      .then((res) => res.json())
      .then((item) => {
        //console.log(item.value);
        Vue.prototype.$VUE_APP_FIXED_DEPT = item.value === "true";
      });
    //console.log("INBOUND_SARABAN");
    fetch(
      `${config.VUE_APP_URL_API_SYSTEM_CONFIG}/api/SystemConfig/GetByKey/INBOUND_SARABAN?API_ACCESS_KEY=${config.VUE_APP_ACCESS_KEY_CONFIG}`
    )
      .then((res) => res.json())
      .then((item) => {
        // console.log("INBOUND_SARABAN");
        //console.log(item.value);
        Vue.prototype.$VUE_APP_INBOUND_SARABAN = item.value === "true";
        //console.log(item.value);
      });

    fetch(
      `${config.VUE_APP_URL_API_SYSTEM_CONFIG}/api/SystemConfig/GetByKey/SECRETARY_PASSED?API_ACCESS_KEY=${config.VUE_APP_ACCESS_KEY_CONFIG}`
    )
      .then((res) => res.json())
      .then((item) => {
        //console.log(item.value);
        Vue.prototype.$VUE_APP_SECRETARY_PASSED = item.value === "true";
      });
  })
  .catch((err) => {
    console.log(err);
    this.$router.push("/").catch(() => { });
  });

Vue.config.productionTip = false;
Vue.component("tinymce", tinymce);
Vue.component("downloadExcel", JsonExcel);
Vue.component("CircularComponent", CircularComponent);

Vue.use(infiniteScroll);
Vue.use(Vuetify);
Vue.use(VueCookies);
Vue.use(VueExcelXlsx);
const opts = {};
export default new Vuetify(opts);


new Vue({
  router: router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
